var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5a4.5 4.5 0 0 0-2.83 8c.46.37.83.8 1.08 1.3.06.12.18.2.32.2h2.86c.14 0 .26-.08.32-.2.25-.5.62-.93 1.08-1.3A4.5 4.5 0 0 0 8 1.5Z",
    fill: "#FFD54A",
    stroke: "#C89B00",
    strokeWidth: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5h3M6.6 13h2.8",
    stroke: "#8A6A00",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.75v1.5M3.1 2.4l1.06 1.06M12.9 2.4l-1.06 1.06M1.75 6.5h1.5M12.75 6.5h1.5",
    stroke: "#F2C94C",
    strokeWidth: 1,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.869fd8a241fd12644c36680fa75294f5.svg";
export { ForwardRef as ReactComponent };